export const panes = [
    {
        menuItem: 'Game 1'
    },
    {
        menuItem: 'Game 2'
    },
    {
        menuItem: 'Game 3'
    },
    {
        menuItem: 'Game 4'
    },
    {
        menuItem: 'Game 5'
    }
]

export const sidebarStaticData = [
    {
        listName:'Assessments Dashboard',
        manuName:'Dashboard',
        path:'/admin',
        iconName:'home icon sidebar-menu-icon'
    },
    {
        listName:'Assessments Reporting',
        manuName:'Reporting',
        path:'/reporting/assessment',
        iconName:'file alternate icon sidebar-menu-icon'
    },
    {
        listName:'Games Dashboard',
        manuName:'Games-Dashboard',
        path:'/admin/game_dashboard',
        iconName:'game icon sidebar-menu-icon'
    },
    {
        listName:'Games Reporting',
        manuName:'Games-Reporting',
        path:'/reporting/games',
        iconName:'newspaper icon sidebar-menu-icon'
    },
    {
        listName:'New Registrations',
        manuName:'New-Registrations',
        path:'/recent_registrations',
        iconName:'edit icon sidebar-menu-icon'
    },
    {
        listName:'Researchers',
        manuName:'Researchers',
        path:'/researchers',
        iconName:'searchengin icon sidebar-menu-icon'
    },
    {
        listName:'Survey Data',
        manuName:'Survey-Data',
        path:'/survey-data',
        iconName:'table icon sidebar-menu-icon'
    },
    {
        listName:'Games Data',
        manuName:'Games-Data',
        path:'/games-data',
        iconName:'calendar alternate  icon sidebar-menu-icon'
    },
    {
        listName:'Organization Management',
        manuName:'0rganization-management',
        path:'/organization-management',
        iconName:'group alternate  icon sidebar-menu-icon'
    },
    {
        listName:'Query Management',
        manuName:'query-management',
        path:'/query-management',
        iconName:'question circle  icon sidebar-menu-icon'
    },
    {
        listName: 'Access Requests',
        manuName: 'Access-Requests',
        path: '/admin/access-requests',
        iconName: 'envelope icon sidebar-menu-icon'
    }

]

export const entrepreneurAdminSidebarData = [
    {
        listName: 'Assessment Users',
        manuName: 'Entrepreneur-Assessment-Users',
        path: '/admin/assessment-users',
        iconName: 'file alternate icon sidebar-menu-icon'
    },
    {
        listName: 'Question and Answer',
        manuName: 'Question-And-Answer',
        path: '/admin/questions-answers',
        iconName: 'question circle icon sidebar-menu-icon'
    },
    {
        listName: 'Access Codes',
        manuName: 'Access-Codes',
        path: '/admin/access-codes',
        iconName: 'edit icon sidebar-menu-icon'
    },
    {
        listName: 'Master Access Codes',
        manuName: 'Master-Access-Codes',
        path: '/admin/master-access-codes',
        iconName: 'key icon sidebar-menu-icon'
    },
    {
        listName: 'Contact us Queries',
        manuName: 'Contact-Us-Queries',
        path: '/admin/contact-us-queries',
        iconName: 'group icon sidebar-menu-icon'
    },
    {
        listName: 'Access Requests',
        manuName: 'Access-Requests',
        path: '/admin/access-requests',
        iconName: 'envelope icon sidebar-menu-icon'
    }
]
